
export default {
    name: 'Plataforma',

    head: {
        title: 'Como enfrentamos a violência contra as mulheres',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content:
                    'A Plataforma Mulher Segura conecta mulheres a serviços de acolhimento online e presenciais, com informação confiável sobre os tipos de violência de gênero.',
            },
            {
                name: 'keywords',
                content:
                    'violencia domestica na quarentena, serviços de acolhimento online, vitimas de violência, tipos de violência de gênero, desenvolvimento populacional, unfpa, onu',
            },
        ],
    },
}
